// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type RanaFeatureFlags,
  RanaFeatureFlagsFromJSON,
  RanaFeatureFlagsToJSON,
} from "../models/RanaFeatureFlags";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

/**
 *
 */
export class FrontendSettingsApi extends runtime.BaseAPI {
  /**
   * Creates request options for getFrontendFeatureFlags without sending the request
   */
  async getFrontendFeatureFlagsRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/frontend-feature-flags`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * V1-Alpha/Get Frontend Feature Flags
   */
  async getFrontendFeatureFlagsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RanaFeatureFlags>> {
    const requestOptions = await this.getFrontendFeatureFlagsRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RanaFeatureFlagsFromJSON(jsonValue)
    );
  }

  /**
   * V1-Alpha/Get Frontend Feature Flags
   */
  async getFrontendFeatureFlags(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RanaFeatureFlags> {
    const response = await this.getFrontendFeatureFlagsRaw(initOverrides);
    return await response.value();
  }
}
